import React from 'react';
import { BsArrowUpRight } from 'react-icons/bs';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const services = [
  {
    name: 'HTML / CSS',
  },
  {
    name: 'TAILWIND CSS',
  },
  {
    name: 'JAVA SCRIPT',
  },
  {
    name: 'JQUERY',
  },
  {
    name: 'BOOTSTRAP',
  },
  {
    name: 'PHP',
  },
  {
    name: 'WORDPRESS',
  },
  {
    name: 'MERN STACK',
  },
  {
    name: 'GIT / GITHUB',
  },
];
const Services = () => {
  return (
    <section className='section h-auto' id='services'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row'>
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1 lg:bg-services lg:bg-bottom bg-no-repeat mix-blend-lighten mb-12 lg:mb-0'>
            <h2 className='h2 text-accent mb-6'>My Skills.</h2>
            <h3 className='h3 max-w-[455px] mb-16'>   I'm a Full Stack Website Developer. with over 1 years of experience.</h3>
            <a href='#work'><button className='btn btn-sm'>See my work</button></a>
          </motion.div>
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'>
            <div>
              {services.map((service, index) => {
                const { name, description, link } = service;
                return (
                  <div className='border-b border-white/20 h-[70px] mb-[10px] flex' key={index}>
                    <div className='max-w-[476px]'>
                      <h4 className='text-[20px] tracking-wider font-primary font-semibold mb-6'>{name}</h4>
                    </div>
                    <div className='flex flex-col flex-1 items-end'>
                      <a href='#' className='btn w-9 h-9 mb-[42px] flex justify-center items-center'>
                        <BsArrowUpRight />
                      </a>
                      <a href='#' className='text-gradient text-sm'>{link}</a>
                    </div>
                  </div>
                  
                );
              })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
};

export default Services;


              